import React from "react"

import { classNames } from "../../utils/class-names"
import { ReactComponent as Logo } from "./images/tremendous-logo.svg"
import * as styles from "./index.module.scss"

interface Props {
  size?: "medium" | "large"
  color?: "blue" | "white"
}

function TremendousLogo({ size = "medium", color = "blue" }: Props) {
  return <Logo className={classNames(styles[size], styles[color])} />
}

export default TremendousLogo
